import { useState, useEffect } from 'react';

export const useCategoryOrder = (categories, activeOrgId) => {
    const handleCategoryOrder = () => {
        let initialOrder;
        let alphabeticalCategories = [...categories].sort((a, b) => a.name.localeCompare(b.name));

        try {
            const saved = localStorage.getItem(`${activeOrgId}_order`);
            if (saved) {
                initialOrder = JSON.parse(saved).map(savedCat => {
                    if (savedCat.id === 'Uncategorized') {
                        return { id: 'Uncategorized', name: 'Uncategorized' };
                    }
                    const cat = categories.find(c => c?.id === savedCat?.id);
                    return cat ? { id: cat.id, name: cat.name } : null;
                }).filter(Boolean);
            } else {
                initialOrder = null;
            }
        } catch (e) {
            console.error("Failed to parse category order from localStorage:", e);
            initialOrder = null;
        }

        if (Array.isArray(alphabeticalCategories) && alphabeticalCategories.length > 0) {
            if (!alphabeticalCategories.some(cat => cat.id === 'Uncategorized')) {
                alphabeticalCategories.push({ id: 'Uncategorized', name: 'Uncategorized' });
            }

            if (initialOrder !== null && Array.isArray(initialOrder)) {
                initialOrder = initialOrder.filter(cat => alphabeticalCategories.some(c => c?.id === cat?.id));

                alphabeticalCategories.forEach(cat => {
                    if (!initialOrder.some(c => c?.id === cat?.id)) {
                        initialOrder.unshift(cat);
                    }
                });
                return initialOrder;
            } else {
                return alphabeticalCategories;
            }
        } else {
            return [{ id: 'Uncategorized', name: 'Uncategorized' }];
        }
    };

    const [categoryOrder, setCategoryOrder] = useState(handleCategoryOrder);

    useEffect(() => {
        if (activeOrgId && categoryOrder) {
            try {
                localStorage.setItem(`${activeOrgId}_order`, JSON.stringify(categoryOrder));
            } catch (e) {
                console.error("Failed to save category order to localStorage:", e);
            }
        }
    }, [categoryOrder, activeOrgId]);

    useEffect(() => {
        setCategoryOrder(handleCategoryOrder());
    }, [categories, activeOrgId]);

    return [categoryOrder, setCategoryOrder];
};